
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: "list",
components: {
Cell,
Group
},
data() {
return {
role: this.$route.query.role,
isAdminRepair: false,
isSrvpRepair: false,
isLog: true
}
},
created() {
let account;
JSON.parse(localStorage.getItem('account')).forEach(item => {
if (item.role === this.role) {
account = item.account;
}
});
this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(res => {
res.data.forEach(item => {
if (item.role === this.role) {
account = item.account;
}
});
this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', {'account': account})
.then(response => {
localStorage.setItem('token', response.data.token);
localStorage.setItem('userid', response.data.userid);
this.$http.get('api/v1/accounts/' + response.data.userid, {
headers: {
token: response.data.token,
opid: response.data.userid
}
}).then(res => {
res.data.forEach(item => {
if (item.type === 'SRVP') {
if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
this.isSrvpRepair = true;
}
this.isLog = item.supported.indexOf('log') !== -1
} else if (item.type === 'ADMIN') {
if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
this.isAdminRepair = true;
}
}
});
})
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/Administrator/list.vue